import { __decorate } from "tslib";
import { Component, Prop, Mixins } from 'vue-property-decorator';
import Draggable from 'vuedraggable';
import Paginator from '@/components/v2/Paginator.vue';
import PaymentMethod from '@/plugins/graphql/queries/v2/payment-methods.gql';
import ActionButton from '@/components/action_button/Index.vue';
import RadioCardItem from '@/components/v2/RadioCardItem.vue';
import { AlertType } from '@/helpers/entities/enums/AlertType';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import { ECOMMERCE_PAGINATION_OPTIONS } from '@/helpers/constants/app';
import SetDefaultPaymentMethod from '@/plugins/graphql/mutations/set-default-payment-method.gql';
import DeletePaymentMethod from '@/plugins/graphql/mutations/delete-payment-method.gql';
import ToggleConfirmationDialog from '@/components/v2/ToggleConfirmationDialog.vue';
import Modal from '@/components/v3/Modal.vue';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
let SavedPaymentMethods = class SavedPaymentMethods extends Mixins(ViewportSizeMixin, AlertMixin, RouterParamsAppMixin, Mixins(FormMixin)) {
    constructor() {
        super(...arguments);
        this.confirmationModal = false;
        this.selectedAction = '';
        this.confirmationMessage = '';
        this.confirmationHeader = '';
        this.defaultPayment = null;
        this.modalOpen = false;
        this.methodUuid = null;
        this.savedPaymentMethods = [];
        this.paginationLimit = 10;
    }
    selectAtion(action, uuid) {
        this.methodUuid = uuid;
        if (action === 'delete') {
            this.selectedAction = 'delete';
            this.confirmationMessage =
                "Are you sure you want to delete this payment method? This action will unlink it from your account. Type 'CONFIRM' to proceed with the deletion.";
            this.confirmationHeader = 'Delete Payment Method Confirmation';
        }
        if (action === 'set') {
            this.selectedAction = 'set';
            this.confirmationMessage =
                "By setting this payment method as your default, you're authorizing its use for monthly recurring payments. Please type 'CONFIRM' to proceed.";
            this.confirmationHeader = 'Set Default Payment Method Confirmation';
        }
        this.confirmationModal = true;
    }
    confirmAction() {
        if (this.selectedAction === 'delete') {
            this.deletePayment(this.methodUuid);
        }
        if (this.selectedAction === 'set') {
            this.setAsDefault(this.methodUuid);
        }
    }
    displayPaymentMethodName(method) {
        if (method.ewallet) {
            return method.ewallet.channel_code;
        }
        if (method.directDebit) {
            return this.directDebitNames(method.directDebit.channel_code);
        }
        if (method.card) {
            return method.card.card_information.network;
        }
    }
    checkPaymentDefault() {
        if (this.defaultPayment) {
            const vm = this;
            return vm.defaultPayment.uuid;
        }
        return '';
    }
    directDebitNames(name) {
        if (name === 'UBP') {
            return 'UnionBank';
        }
        if (name === 'RCBC') {
            return 'RCBC';
        }
    }
    formCallback(action) {
        if (action === 'delete') {
            const message = 'Successfully Deleted Payment Method';
            this.toggleAlert(message, AlertType.success);
        }
        if (action === 'set') {
            const message = 'Successfully Changed Default Payment Method';
            this.toggleAlert(message, AlertType.success);
        }
    }
    async setAsDefault(uuid) {
        try {
            await this.$apollo.mutate({
                mutation: SetDefaultPaymentMethod,
                variables: {
                    input: {
                        xenditPaymentMethodUuid: uuid,
                    },
                },
            });
            this.formCallback('set');
        }
        catch (e) {
            this.errorNotification(e.message);
        }
        finally {
            this.$apollo.queries.savedPaymentMethods.refetch();
            this.isRequestOnProcess = false;
            this.confirmationModal = false;
        }
    }
    checkDefault(method) {
        if (method.isDefault) {
            this.methodUuid = method.uuid;
            this.modalOpen = true;
        }
    }
    async deletePayment(uuid) {
        try {
            this.isRequestOnProcess = true;
            await this.$apollo.mutate({
                mutation: DeletePaymentMethod,
                variables: {
                    input: {
                        xenditPaymentMethodUuid: uuid,
                    },
                },
            });
            this.modalOpen = false;
            this.formCallback('delete');
        }
        catch (e) {
            this.errorNotification(e.message);
        }
        finally {
            this.$apollo.queries.savedPaymentMethods.refetch();
            this.isRequestOnProcess = false;
            this.confirmationModal = false;
        }
    }
    paginationOptions(totalCount) {
        const index = ECOMMERCE_PAGINATION_OPTIONS.findIndex((v) => v >= totalCount) + 1;
        return index === 0
            ? ECOMMERCE_PAGINATION_OPTIONS
            : ECOMMERCE_PAGINATION_OPTIONS.slice(0, index);
    }
    displayPaginator(total) {
        return total > this.paginationLimit;
    }
    get pageTitle() {
        return this.$route.meta.title;
    }
};
__decorate([
    Prop({ type: String, default: null })
], SavedPaymentMethods.prototype, "categoryUuid", void 0);
__decorate([
    Prop({ type: String, default: null })
], SavedPaymentMethods.prototype, "keyword", void 0);
SavedPaymentMethods = __decorate([
    Component({
        components: {
            RadioCardItem,
            Draggable,
            Paginator,
            Modal,
            ActionButton,
            ToggleConfirmationDialog,
        },
        apollo: {
            savedPaymentMethods: {
                query: PaymentMethod,
                variables() {
                    return {
                        appUuid: this.$route.params.appUUID,
                    };
                },
                fetchPolicy: 'cache-and-network',
                update(data) {
                    const methods = data.fetchPaymentMethods;
                    this.savedPaymentMethods = methods;
                    const defaultPay = methods.find((method) => method.isDefault);
                    this.defaultPayment = defaultPay;
                    return methods;
                },
            },
        },
    })
], SavedPaymentMethods);
export default SavedPaymentMethods;
